import { Vector2 } from "three";
function sort2dObjsbyVector(objs, vector, transformerFunc = (x) => x) {
  const normV = new Vector2(...vector).normalize();
  const sorted = objs.slice().sort((a, b) => {
    const aPos = transformerFunc(a.pos);
    const bPos = transformerFunc(b.pos);
    const aProjected = aPos[0] * normV.x + (aPos[2] || aPos[1]) * normV.y;
    const bProjected = bPos[0] * normV.x + (bPos[2] || bPos[1]) * normV.y;
    return aProjected - bProjected;
  });
  return sorted;
}
export {
  sort2dObjsbyVector
};
//# sourceMappingURL=index158.js.map
